class NativeLogsError extends Error {
  constructor(reason) {
    super(reason);
    this.name = 'NativeLogsError';
  }
}

export default NativeLogsError;
